export default {
  path: '/legal',
  meta: {
    title: '权益激活',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/legal`),
}



// WEBPACK FOOTER //
// ./src/views/LegalRight/router.js